import type { RouteRecordRaw } from 'vue-router'

import { PAGE_NOT_FOUND_NAME, EXCEPTION_PAGE } from '../constant'

export const PAGE_NOT_FOUND_ROUTE: RouteRecordRaw = {
  path: '/:path(.*)*',
  name: PAGE_NOT_FOUND_NAME,
  component: EXCEPTION_PAGE,
  meta: { title: PAGE_NOT_FOUND_NAME },
}
